/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ISmweNavigationMenu contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum navigationMenuSource {
    retailServerOnly = 'retailServerOnly',
    cmsOnly = 'cmsOnly',
    all = 'all'
}

export const enum alignment {
    left = 'left',
    center = 'center',
    right = 'right'
}

export interface ISmweNavigationMenuConfig extends Msdyn365.IModuleConfig {
    topLvlCategory?: Msdyn365.ILinkData;
    topLvlCategoryText?: string;
    navigationMenuSource?: navigationMenuSource;
    cmsNavItems?: ICmsNavItemsData[];
    className?: string;
    hideRetailAllMenu?: boolean;
    hiddenRetailMenuItems?: string;
    alignment?: alignment;
    sliceIndex?: number;
    cmsRetailItemMenu?: ICmsRetailItemMenuData;
    overFlowMenuText?: string;
    initialOverFlowMenuCount?: number;
}

export interface ISmweNavigationMenuResources {
    menuAriaLabel: string;
    backButtonAriaLabel: string;
    allCategoryMenuText: string;
}

export interface ICmsNavItemsData {
    linkText?: string;
    linkUrl?: Msdyn365.ILinkData;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
    subMenus?: ISubMenusData[];
}

export interface ICmsRetailItemMenuData {
    menu?: IMenuData[];
}

export interface ISubMenusData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    subMenus?: ISubMenusData[];
}

export interface IMenuData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    altStyle?: boolean;
    sliceIndex?: number;
}

export interface ISubMenusData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
}

export interface ISmweNavigationMenuProps<T> extends Msdyn365.IModule<T> {
    resources: ISmweNavigationMenuResources;
    config: ISmweNavigationMenuConfig;
}
